module.exports = __webpack_public_path__ + "static/media/Lissandra_0.09bed674.jpg";